import React from 'react';

import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

export default function SelectValue({ value, onChange, defaultOptions = [], createable = false, required = false }) {
  const { t } = useTranslation();

  const handleChange = (val) => {
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      placeholder={t('common.placeholder.please_select')}
      allowClear={!required}
      options={defaultOptions}
      style={{ width: '100%' }}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
}
